// extracted by mini-css-extract-plugin
export default {"compressedAssigneeAvatar":"CompressedAssigneeAnchor-module__compressedAssigneeAvatar--y2Hg2"};